module.exports = __webpack_public_path__ + "static/media/app-icon-nobg.0322ad00.svg";